define('BookingEngine/app-Confirmation/settings',[],function () {
    return {
        container: "#confirm",
        getItinerary: "/basketitinerary/index",
    };
});
